import { Chem } from "#/declarations";

//TODO: Separate constant file of representations, as some are shared
export const FUNCTIONAL_GROUPS: Array<Chem.Group> = [
  {
    name: "Alcohol O-H (concentrate)",
    id: "alcohol-o-h-concentrate",
    peak: {
      min: 3200,
      max: 3550,
      shape: "broad, strong",
    },
    spriteParams: {
      width: 45.65,
      height: 61.5,
    },
    build: [
      {
        structure: "alcohol",
      },
    ],
  },
  {
    name: "Alcohol O-H (dilute)",
    id: "alcohol-o-h-dilute",
    spriteParams: {
      width: 45.65,
      height: 61.5,
    },
    peak: {
      min: 3590,
      max: 3650,
      shape: "sharp, variable",
    },
    build: [
      {
        structure: "alcohol",
      },
    ],
  },
  {
    name: "Aldehyde C-H",
    id: "aldehyde-c-h",
    peak: {
      min: 2700,
      max: 2900,
      shape: "variable",
    },
    spriteParams: {
      width: 67.3,
      height: 61.5,
    },
    build: [
      {
        structure: "aldehyde",
        options: { showHydrogen: true },
      },
    ],
  },
  {
    name: "Aldehyde C-O",
    id: "aldehyde-c-o",
    peak: {
      min: 1630,
      max: 1780,
      shape: "variable",
    },
    spriteParams: {
      width: 67.3,
      height: 61.5,
    },
    build: [
      {
        structure: "aldehyde",
        options: { showHydrogen: true },
      },
    ],
  },
  {
    name: "Alkene C-H Stretch",
    id: "alkene-c-h-stretch",
    peak: {
      min: 3010,
      max: 3095,
      shape: "medium",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 86.5,
    },
    build: [
      {
        structure: "alkene",
      },
    ],
  },
  {
    name: "Alkene C=C Stretch",
    id: "alkene-cc-stretch",
    peak: {
      min: 1620,
      max: 1680,
      shape: "variable",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 86.5,
    },
    build: [
      {
        structure: "alkene",
      },
    ],
  },
  {
    name: "Alkyl C-H Stretch",
    id: "alkyl-c-h-stretch",
    peak: {
      min: 2850,
      max: 2960,
      shape: "medium - strong",
    },
    spriteParams: {
      width: 74,
      height: 74,
    },
    build: [
      {
        structure: "ch",
        options: {
          showHydrogen: true,
          label: ["c1"],
        },
      },
    ],
  },
  {
    name: "Alkyne C-H",
    id: "alkyne-c-h",
    peak: {
      min: 3300,
      max: 3300,
      shape: "strong",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 61.5,
    },
    build: [
      {
        structure: "alkyne",
      },
    ],
  },
  {
    name: "Alkyne C≡C",
    id: "alkyne-ctripc",
    peak: {
      min: 2100,
      max: 2260,
      shape: "variable",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 61.5,
    },
    build: [
      {
        structure: "alkyne",
      },
    ],
  },
  {
    name: "Amide C=O",
    id: "amide-co",
    peak: {
      min: 1630,
      max: 1690,
      shape: "strong",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 86.5,
    },
    build: [
      {
        structure: "amide",
      },
    ],
  },
  {
    name: "Amide N-H",
    id: "amide-n-h",
    peak: {
      min: 3350,
      max: 3500,
      shape: "variable",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 86.5,
    },
    build: [
      {
        structure: "amide",
      },
    ],
  },
  {
    name: "Amine N-H Bend",
    id: "amine-n-h-bend",
    peak: {
      min: 1500,
      max: 1600,
      shape: "strong",
    },
    spriteParams: {
      width: 67.3,
      height: 61.5,
    },
    build: [
      {
        structure: "amine",
      },
    ],
  },
  {
    name: "Amine N-H Stretch",
    id: "amine-n-h-stretch",
    peak: {
      min: 3300,
      max: 3500,
      shape: "medium",
    },
    spriteParams: {
      width: 67.3,
      height: 61.5,
    },
    build: [
      {
        structure: "amine",
      },
    ],
  },
  {
    name: "Aromatic C-H Stretch",
    id: "aromatic-c-h-stretch",
    peak: {
      min: 3030,
      max: 3030,
      shape: "variable",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 74,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    name: "Aromatic C=C Stretch",
    id: "aromatic-cc-stretch",
    peak: {
      min: 1450,
      max: 1600,
      shape: "variable",
    },
    spriteParams: {
      width: 67.3,
      height: 74,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
      },
    ],
  },
  {
    name: "C-O",
    id: "c-o",
    peak: {
      min: 1000,
      max: 1300,
      shape: "variable",
    },
    spriteParams: {
      width: 74,
      height: 74,
    },
    build: [
      {
        structure: "c-o",
      },
    ],
  },
  {
    name: "Carboxylic Acid C=O",
    id: "carboxylic-acid-co",
    peak: {
      min: 1710,
      max: 1780,
      shape: "strong",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 61.5,
    },
    build: [
      {
        structure: "carboxylic-acid",
      },
    ],
  },
  {
    name: "Carboxylic Acid O-H",
    id: "carboxylic-acid-o-h",

    peak: {
      min: 2500,
      max: 3000,
      shape: "variable",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 61.5,
    },
    build: [
      {
        structure: "carboxylic-acid",
      },
    ],
  },
  {
    name: "Ester C=O",
    id: "ester-co",
    peak: {
      min: 1735,
      max: 1750,
      shape: "strong",
    },
    spriteParams: {
      width: 88.94999999999999,
      height: 61.5,
    },
    build: [
      {
        structure: "ester",
      },
    ],
  },
  {
    name: "Ketone C=O",
    id: "ketone-co",
    peak: {
      min: 1680,
      max: 1750,
      shape: "strong",
    },
    spriteParams: {
      width: 67.3,
      height: 61.5,
    },
    build: [
      {
        structure: "ketone",
      },
    ],
  },
  {
    name: "Nitrile C≡N",
    id: "nitrile-ctripn",
    peak: {
      min: 2220,
      max: 2260,
      shape: "medium",
    },
    spriteParams: {
      width: 32,
      height: 74,
    },
    build: [
      {
        structure: "nitrile",
      },
    ],
  },
  {
    name: "Chlorine",
    id: "chlorine",
    peak: {
      min: 750,
      max: 750,
      shape: "strong, sharp",
    },
    spriteParams: {
      width: 24,
      height: 44,
    },
    build: [
      {
        structure: "chlorine",
      },
    ],
  },
];
